import request from "@/utils/request";
import { resolveAppBaseUrl, resolveDetectImageApi } from "@/microfrontends/monitor-mfe/sdk/sdk-api-config";

const HTTP_PREFIX = '/wayline/'

export interface DetectParam {
  inputUrl: string;
  outputType: string;
  deviceSn: string;
  modelType: number;
  taskId: string;
}

const getModelStreamUrl = (model_id: number) => {
  switch (model_id) {
    case 1:
      return resolveAppBaseUrl() + `/detect/traffic/rtsp`;
    case 2:
      return `/uav/recognition/video`;
    case 4:
      return resolveDetectImageApi() + `/detect/ship/rtsp`;
    default:
      return resolveDetectImageApi() + `/detect/traffic/rtsp`;
  }
};

// Get Device Topo
export const getDeviceTopo1 = async function (
  body: {}
): Promise<any> {
  const url = `/uav/manage/device/list`;
  const result = await request.post(url, body);
  return result.data;
};

// Get player Capacity
export const getLiveCapacityBySn = async function (sn: string): Promise<any> {
  const url = `/uav/manage/live/capacity/${sn}`;
  const result = await request.get(url);
  return result.data;
};

// Start Livestream
export const startLivestream = async function (body: {}): Promise<any> {
  const url = `/uav/manage/live/streams/start`;
  const result = await request.post(url, body);
  console.log("startLivestream", result);
  return result.data;
};

//获取视频识别流地址
export async function GetDetectStreamAddr(
  params: DetectParam,
  model_id: number
) {
  const url = getModelStreamUrl(model_id);
  console.log("视频识别请求地址:========>>>>>>", url);
  const resp = await request.post(url, params);
  return resp.data;
}

// 任务执行
export const createFlightTasks = async function (body:any): Promise<any>{
  const url = `/uav/job/add`
  const result = await request.post(url, body)
  return result.data
}


export const getUnreadDeviceHms = async function (body:any): Promise<any> {
  const url = `/uav/manage/device/hms/deviceHmsList`
  const result = await request.post(url,body)
  return result.data
}
